module.exports = __webpack_public_path__ + "static/Bnner-8da180f129b26523fdc21bb39c9e0d63.png";